import { ExternalLink } from "lucide-react";
import React from "react";
import { getMRLink } from "../utils";
import { Tooltip, TooltipBadgeContent } from "./Tooltip";

// Icon-only anchor that opens the merge request in GitLab in a new tab
// (or the OS default browser when running inside Electron/Tauri).
export const OpenInGitLabButton = ({ mr, className = "" }) => {
	const href = getMRLink(mr);
	if (!href) return null;

	return (
		<Tooltip
			content={
				<TooltipBadgeContent badge="Open">
					Open merge request in GitLab.
				</TooltipBadgeContent>
			}
		>
			<a
				href={href}
				target="_blank"
				rel="noopener noreferrer"
				draggable="false"
				aria-label="Open merge request in GitLab"
				onClick={(e) => e.stopPropagation()}
				className={`inline-flex h-6 w-6 items-center justify-center rounded hover:bg-[var(--color-bg-secondary)] text-[var(--color-text-secondary)] hover:text-[var(--color-link)] transition-colors ${className}`}
			>
				<ExternalLink className="w-4 h-4" />
			</a>
		</Tooltip>
	);
};

export default OpenInGitLabButton;
